import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IChartPeriodProps, IChartPeriodSelectionConfiguration, IChartPeriodState } from './models/index.js';
import {
	CHART_PERIOD_SELECTION_CATEGORY_KEY,
	CHART_PERIOD_SELECTION_COMPONENT_KEY,
} from './ChartPeriodSelection.meta.js';

export class ChartPeriod extends ComponentBase<
	IChartPeriodProps,
	IChartPeriodState,
	IChartPeriodSelectionConfiguration
> {
	categoryKey = CHART_PERIOD_SELECTION_CATEGORY_KEY;
	componentKey = CHART_PERIOD_SELECTION_COMPONENT_KEY;

	buttonRef: any;

	constructor(props: IChartPeriodProps) {
		super(props);
		this.buttonRef = React.createRef();
	}

	componentDidMount() {
		this.setFocus();
	}

	componentDidUpdate() {
		this.setFocus();
	}

	setFocus() {
		const { focused } = this.props;
		if (focused) {
			this.buttonRef.current.focus();
		}
	}

	render() {
		const { className, id, onKeyDown, onClick, children, active, disabled } = this.props;
		return (
			<button
				className={className}
				id={id}
				onClick={onClick}
				onKeyDown={onKeyDown}
				aria-pressed={active}
				disabled={disabled}
				ref={this.buttonRef}
			>
				{children}
			</button>
		);
	}
}

export default InjectedStyledComponent(
	observer(ChartPeriod),
	CHART_PERIOD_SELECTION_CATEGORY_KEY,
	CHART_PERIOD_SELECTION_COMPONENT_KEY,
	['chartPeriod'],
);
